import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import { collegeApplicationRoadmapContent } from '../content';

const { header, heroCallout, timeline, finalThoughts } = collegeApplicationRoadmapContent;

export const useAgentContext = () => {
  useRegisterAgentContext({
    kind: 'section',
    title: 'Overview',
    description:
      'Introductory section framing the college application as a decision about options, story, and long-term fit rather than paperwork.',
    detail: [
      `The roadmap covers ${timeline.overviewCard.overview.toLowerCase()}.`,
      ...header.description,
      `${heroCallout.title}: ${heroCallout.body}`,
    ].join('\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: timeline.title,
    description:
      'Month-by-month college application timeline from April of junior year through December of senior year, with focus items, definitions, and Backrs tools for each month.',
    detail: timeline.months
      .map((month) =>
        [
          `${[month.period.label, month.period.caption].filter(Boolean).join(' · ')} — ${month.title} (${month.badge})`,
          month.overview,
          ...month.body,
          ...(month.definitions ?? []).map((def) => `${def.term}: ${def.body}`),
          `Focus: ${month.focus.join('; ')}`,
          ...(month.callout ? [`${month.callout.title}: ${month.callout.body}`] : []),
          `Tools: ${[...month.toolIds, ...(month.nuggetSlugs ?? [])].join(', ')}`,
        ].join('\n'),
      )
      .join('\n\n'),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: finalThoughts.title,
    description: 'Closing guidance on how to approach the college application process well.',
    detail: [
      finalThoughts.lead,
      ...finalThoughts.thoughts.map((thought) => `${thought.title}: ${thought.body}`),
      `${finalThoughts.callout.title}: ${finalThoughts.callout.body}`,
    ].join('\n'),
  });
};
